import React from 'react'
import clsx from 'clsx'

import { TableCell } from '@material-ui/core'

const ZariTableCell = ({ className, ...props }) => {
  return <TableCell className={clsx('zr-td', className)} {...props} />
}

export default ZariTableCell
